import { Breadcrumb, Button, Image, message, Popconfirm, Space, Tag } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { DeleteOutlined, EditOutlined, EyeOutlined, HomeOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import service from "../../api/FetchInterceptor";
import DataTable from "../../components/dataTable";
import { formatMoney } from "../../lib/money";
import AddFormation from "./add";

const Formations = () => {
    const navigate = useNavigate();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const refresh = () => setRefreshTrigger((prev) => prev + 1);

    const openCreate = () => {
        setEditId(null);
        setDrawerOpen(true);
    };

    const openEdit = (id) => {
        setEditId(id);
        setDrawerOpen(true);
    };

    const remove = (id) => {
        service({ method: "DELETE", url: `admin/formations/${id}` })
            .then(() => {
                message.success("Formation supprimée");
                refresh();
            })
            .catch(() => message.error("Erreur lors de la suppression"));
    };

    const columns = [
        {
            key: "cover",
            width: 80,
            render: (_, record) =>
                record.cover_image_url ? (
                    <Image src={record.cover_image_url} width={56} height={56} style={{ objectFit: "cover", borderRadius: 8 }} />
                ) : (
                    <div className="h-14 w-14 rounded-lg bg-gray-100" />
                ),
        },
        {
            key: "title",
            dataIndex: "title",
            title: "Titre",
            render: (title, record) => (
                <div>
                    <div className="font-medium">{title}</div>
                    {record.subtitle && <div className="text-xs text-gray-500">{record.subtitle}</div>}
                </div>
            ),
        },
        {
            key: "is_published",
            dataIndex: "is_published",
            title: "Statut",
            render: (published) => (published ? <Tag color="green">Publiée</Tag> : <Tag>Brouillon</Tag>),
        },
        {
            key: "parts_count",
            dataIndex: "parts_count",
            title: "Parties",
        },
        {
            key: "prices",
            dataIndex: "prices",
            title: "Prix",
            render: (prices = []) =>
                prices.length ? (
                    <Space size={[4, 4]} wrap>
                        {prices.map((p) => (
                            <Tag key={p.id} color={p.is_active ? "blue" : "default"}>
                                {formatMoney(p.amount_major, p.currency)}
                            </Tag>
                        ))}
                    </Space>
                ) : (
                    <span className="text-gray-400">Aucun prix</span>
                ),
        },
        {
            key: "enrollments_count",
            dataIndex: "enrollments_count",
            title: "Inscrites",
        },
        {
            key: "created_at",
            dataIndex: "created_at",
            title: "Créée le",
            render: (created_at) => dayjs(created_at).format("DD/MM/YYYY"),
        },
        {
            title: "",
            width: 150,
            render: (_, record) => (
                <Space>
                    <Button type="text" icon={<EyeOutlined />} title="Ouvrir" onClick={() => navigate(`/dashboard/formations/${record.id}`)} />
                    <Button type="text" icon={<EditOutlined />} title="Modifier" onClick={() => openEdit(record.id)} />
                    <Popconfirm
                        title="Supprimer cette formation ?"
                        description="Les achats et accès existants sont conservés."
                        okText="Supprimer"
                        cancelText="Annuler"
                        okButtonProps={{ danger: true }}
                        onConfirm={() => remove(record.id)}
                    >
                        <Button type="text" danger icon={<DeleteOutlined />} title="Supprimer" />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <>
            <AddFormation
                id={editId}
                open={drawerOpen}
                setOpen={setDrawerOpen}
                onSuccess={(formation) => {
                    refresh();
                    // Après une création, on ouvre directement la formation pour ajouter les parties.
                    if (!editId && formation?.id) navigate(`/dashboard/formations/${formation.id}`);
                }}
            />

            <div className="flex flex-row mt-8">
                <Breadcrumb
                    items={[
                        { href: "/dashboard", title: <HomeOutlined /> },
                        { title: "Formations" },
                    ]}
                />

                <div className="ml-auto">
                    <Button icon={<PlusOutlined />} onClick={openCreate} type="primary">
                        Ajouter une formation
                    </Button>
                </div>
            </div>

            <DataTable
                url="/admin/formations"
                columns={columns}
                refreshTrigger={refreshTrigger}
                pagination={false}
                search={false}
            />
        </>
    );
};

export default Formations;
